import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { ChevronDown, ChevronUp } from 'lucide-react';

const sideMenuStructure = [
  { type: 'group', title: '系统设置', items: [
    { to: '/batch-management', label: '测评批次管理' },
    { to: '/indicator-management', label: '测评指标管理' },
    { to: '/scoring-parameter-config', label: '评分参数配置' },
  ] },
  { type: 'item', to: '/baseline-roster', label: '评奖评优基准名单管理' },
  { type: 'item', to: '/panel-management', label: '评议小组管理' },
  { type: 'group', title: '学生互评管理', items: [
    { to: '/peer-review-tasks', label: '互评任务管理' },
    { to: '/malicious-scoring', label: '恶意打分记录' },
  ] },
  { type: 'group', title: '参评成绩管理', items: [
    { to: '/academic-score-management', label: '学期学习成绩管理' },
  ] },
  { type: 'group', title: '综合测评审核', items: [
    { to: '/bonus-audit', label: '加分项审核' },
  ] },
  { type: 'group', title: '教师综合评价', items: [
    { to: '/counselor-scoring', label: '辅导员分数评议' },
    { to: '/quality-scoring', label: '综合素质评分' },
  ] },
  { type: 'group', title: '学生综合测评', items: [
    { to: '/student-bonus', label: '学生加分管理' },
    { to: '/assessment-summary', label: '学生综合测评汇总' },
    { to: '/assessment-query', label: '综合测评成绩查询' },
  ] },
  { type: 'group', title: '我的综合测评（学生端）', items: [
    { to: '/my-bonus', label: '我的加分项' },
    { to: '/my-assessment-score', label: '我的综合测评成绩' },
    { to: '/my-peer-review', label: '我的互评任务' },
  ] },
  { type: 'group', title: '页面模板', items: [
    { to: '/template-page', label: '普通列表页模板' },
    { to: '/template-tabbed-page', label: 'Tab列表页模板' },
  ] },
];

export default function Sidebar() {
  const [expandedGroups, setExpandedGroups] = useState(
    sideMenuStructure.filter(m => m.type === 'group').map(m => m.title)
  );

  const toggleGroup = (title) => {
    setExpandedGroups(prev => prev.includes(title) ? prev.filter(t => t !== title) : [...prev, title]);
  };

  return (
    <aside className="w-[240px] bg-white border-r border-gray-200 overflow-y-auto flex flex-col py-3 select-none z-0 shadow-[2px_0_10px_rgba(0,0,0,0.02)]">
      {sideMenuStructure.map((menu, index) => {
        if (menu.type === 'item') {
          return (
            <NavLink
              key={index}
              to={menu.to}
              className={({ isActive }) => `py-3 px-6 text-[14px] cursor-pointer transition-colors mt-0.5 ${isActive ? 'bg-[#e6f4ff] text-[#1890ff] border-r-[3px] border-[#1890ff]' : 'text-gray-700 hover:bg-[#f5f8ff]'}`}
            >
              {menu.label}
            </NavLink>
          );
        }

        const isExpanded = expandedGroups.includes(menu.title);
        return (
          <div key={index} className="flex flex-col py-0.5 mt-1">
            <div onClick={() => toggleGroup(menu.title)} className="px-6 py-2.5 text-gray-700 text-[14px] flex justify-between items-center cursor-pointer hover:bg-gray-50 transition-colors">
              <span>{menu.title}</span>
              {isExpanded ? <ChevronUp size={16} className="text-gray-400" /> : <ChevronDown size={16} className="text-gray-400" />}
            </div>
            {isExpanded && menu.items.map(item => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) => `py-2.5 text-[14px] cursor-pointer transition-colors pl-10 pr-6 ${isActive ? 'bg-[#e6f4ff] text-[#1890ff] border-r-[3px] border-[#1890ff]' : 'text-gray-600 hover:bg-[#f5f8ff]'}`}
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        );
      })}
    </aside>
  );
}
